import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import styles from './alert.module.scss';

const Alert = () => (
  <Card className={styles.alertCard}>
    <CardTitle className={styles.cardTitle}>
      <span className={styles.center}>Alerts</span>
    </CardTitle>
    <hr className={styles.hrLine} />
    <CardBody />
  </Card>
);

export default Alert;
